var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6 -5 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M18.47,3.843,21.777,0h-.783L18.122,3.337,15.83,0H13.185l3.467,5.046-3.467,4.03h.784L17,5.552l2.421,3.524h2.645l-3.6-5.233ZM17.4,5.091l-.351-.5-2.8-4h1.2L17.71,3.817l.351.5,2.932,4.194h-1.2L17.4,5.091Z",
    transform: "translate(-13.185)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b170c274ca2088edc674c98851be7d92.svg";
export { ForwardRef as ReactComponent };